import { graphql, HttpResponse } from 'msw'
import { type EnrollmentAccountSelectionData, type EnrollmentAccountSelectionSubmitOutput } from '../../../models'

export const getEnrollmentAccountSelectionDataMock: EnrollmentAccountSelectionData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/account-selection',
}

export const submitEnrollmentAccountSelectionDataMock: EnrollmentAccountSelectionSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/mode-selection',
}

export const mockGetEnrollmentAccountSelectionData = graphql.mutation('getEnrollmentAccountSelectionData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentAccountSelectionDataMock } })
})

export const mockSubmitEnrollmentAccountSelectionData = graphql.mutation('submitEnrollmentAccountSelectionData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentAccountSelectionDataMock } })
})

export const mockEnrollmentAccountSelection = [
  mockGetEnrollmentAccountSelectionData,
  mockSubmitEnrollmentAccountSelectionData,
]
